import { type PropsWithChildren, PureComponent, type ReactNode } from 'react';

import classNames from 'classnames';

import { FLAG_SIMPLIFIED_ACLS } from '@iconik-io/shared-lib/src/analytics/flags';
import { growthbook } from '@iconik-io/shared-lib/src/analytics/growthbook';

import { permissionsOptions } from '../../../constants/data';
import SelectFieldWrapper from '../../../ui/forms/field_wrappers/select/select';
import SelectGroupsFieldWrapper from '../../../ui/forms/field_wrappers/select_groups/select_groups';
import SelectTeamsFieldWrapper from '../../../ui/forms/field_wrappers/select_teams/select_teams';
import SelectUsersFieldWrapper from '../../../ui/forms/field_wrappers/select_users/select_users';
import Form from '../../../ui/forms/form';
import type { SelectOption } from '../../../ui/select_field/types';

import styles from './acls_form.module.css';

export type AclsFormData = {
  user_ids: string[];
  group_ids: string[];
  permissions: SelectOption[];
  propagate: boolean;
};

type Props = PropsWithChildren<{
  className?: string;
  onValidAclFormSubmit: (
    data: AclsFormData,
    reset?: (model?: AclsFormData) => void,
  ) => void;
  onChange: (data: AclsFormData) => void;
  isModal?: boolean;
  additionalTeamOptions?: SelectOption[];
}>;

class AclsForm extends PureComponent<Props> {
  render(): ReactNode {
    const {
      onValidAclFormSubmit,
      children,
      className,
      onChange,
      additionalTeamOptions,
    } = this.props;
    const showSimplifiedAcls = growthbook?.isOn(FLAG_SIMPLIFIED_ACLS) ?? false;
    return (
      <Form
        className={classNames(className, styles.form)}
        onValidSubmit={onValidAclFormSubmit}
        onChange={onChange}
        submitByCommand
      >
        <SelectUsersFieldWrapper
          canClear
          placeholder="Users"
          isMulti
          name="user_ids"
          plainMultiValues
        />
        {showSimplifiedAcls ? (
          <SelectTeamsFieldWrapper
            canClear
            placeholder="Teams"
            isMulti
            name="group_ids"
            plainMultiValues
            additionalOptions={additionalTeamOptions}
          />
        ) : (
          <SelectGroupsFieldWrapper
            canClear
            placeholder="Groups"
            isMulti
            name="group_ids"
            plainMultiValues
          />
        )}
        <div>
          <SelectFieldWrapper
            required
            isMulti
            options={permissionsOptions}
            name="permissions"
            placeholder="Permissions"
          />
        </div>
        {children}
      </Form>
    );
  }
}

export default AclsForm;
